export default __webpack_public_path__ + "static/appendix-c32a72635df3a01bd363954fa5f5d697.png";